import {SurveyPreset} from 'client/common/types/survey';

export interface QuestionBankItem {
    id: number;
    initial: SurveyPreset[];
    hidden: boolean;
    config: {label: string};
}

export interface QuestionBankStore {
    preset?: SurveyPreset;
}

export interface SelectPresetPayload {
    preset: SurveyPreset;
}

const SIMPLE_TEMPLATES = [
    SurveyPreset.SimpleMarketAnalysis,
    SurveyPreset.SimpleCompetitorAnalysis,
    SurveyPreset.SimplePriceSensitivityMeter,
    SurveyPreset.SimpleCustomerAnalytics,
    SurveyPreset.SimpleProductConceptTesting,
    SurveyPreset.SimpleNameTesting,
    SurveyPreset.SimpleDesignEvaluation
];

export function isSimpleTemplate(preset: SurveyPreset): boolean {
    return SIMPLE_TEMPLATES.includes(preset);
}

export function isSurveyPreset(preset: string): preset is SurveyPreset {
    return Object.values(SurveyPreset).includes(preset as SurveyPreset);
}
